if (document.head.querySelector('meta[property="adtech"]')) {
  if (window.adgroupid === undefined) { window.adgroupid = Math.round(Math.random() * 1000); }
  var ADTECH = {};
  ADTECH.loadAd = function (a, c, d, b) {
    a = document.getElementById(a);
    a.style.width = c + 'px';
    a.style.height = d + 'px';
    a.innerHTML = '';
    b = (typeof ADTECH_ASYNCIF_PATH !== 'undefined' ? window.ADTECH_ASYNCIF_PATH : 'ADTECHASyncIF.html') + '#' + escape(b);
    a.innerHTML = '<iframe width="' + c + '" height="' + d + '" src ="' + b + '" frameborder="0" marginwidth="0" marginheight="0" allowtransparency="true" scrolling="no"></iframe>';
  };
  window.ADTECH_ASYNCIF_PATH = '/adtech_asyncif.html';
}
